// For static/print maps, we only need to show this text.
const copyright = '\u00A9';
export const ATTRIBUTION_TEXT = `${copyright} URBANFOOTPRINT ${copyright} MAPBOX ${copyright} OPENSTREETMAP`;
